import { pipe } from 'lodash/fp';
import { withReact } from 'slate-react';
import { withHistory } from 'slate-history';
import { withMentions } from './withMentions';
import { withLinks } from './withLinks';
import { CustomEditor } from '../../../../models/slate-editor';
import { Editor } from 'slate';
import { withPastedData } from './withPastedData';
import { withNormalization } from './withNormalization';

export declare type CreateEditorFunction = (arg: Editor) => CustomEditor;
export const createEditorWithPlugins: CreateEditorFunction = arg => {
  return pipe(withReact, withHistory, withNormalization, withMentions, withLinks, withPastedData)(arg);
};

export const createFirstCommentEditor: CreateEditorFunction = arg => {
  return pipe(withReact, withHistory, withNormalization, withPastedData)(arg);
};
